import type { ReactNode } from "react";

interface DetailFieldProps {
    label: string;
    children: ReactNode;
}

export const DetailField = ({ label, children }: DetailFieldProps) => (
    <div>
        <dt className="text-xs uppercase tracking-wide text-neutral/60">
            {label}
        </dt>
        <dd className="mt-0.5">{children || "—"}</dd>
    </div>
);
